/** Extracts a safe string error message from an unknown error object. */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return friendlyErrorText(error.message);
  if (typeof error === 'string') return friendlyErrorText(error);
  return 'Ocurrió un error inesperado.';
}

function friendlyErrorText(message: string): string {
  const lower = message.toLowerCase();
  if (lower.includes('failed to fetch') || lower.includes('networkerror') || lower.includes('load failed')) {
    return 'Sin conexión con el servidor.';
  }
  return message;
}
